import { usePlatformConfig } from "@aurem/components";
import { useEnvironmentDocuments } from "hooks/useEnvironmentDocuments";
import { Language } from "providers/I18nProvider";
import { EnvironmentDocumentType } from "types/graphql/graphql";

export function useTermsDocumentUrl(language: Language): string | undefined {
  const platformConfig = usePlatformConfig();
  const { documents } = useEnvironmentDocuments(platformConfig?.id ?? "");

  const uploadedTermsDocument = documents.find(
    (document: { type?: EnvironmentDocumentType }) =>
      document.type === EnvironmentDocumentType.Terms,
  );

  return (
    uploadedTermsDocument?.files?.[language] ?? uploadedTermsDocument?.files?.en
  );
}
